module.exports = __webpack_public_path__ + "static/img/chuantong.2a49810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seo/chuantong.png
// module id = 47Kp
// module chunks = 69